<script lang="ts" setup>
import { DocumentState } from "~/types/enums/DocumentState";

const props = defineProps({
  state: {
    type: String,
    required: true,
  },
  filled: {
    type: Boolean,
    default: true,
  },
  isStudent: {
    type: Boolean,
    default: false,
  },
  isConsolidatedView: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const stateLabel = computed(() => {
  switch (props.state) {
    case DocumentState.pending:
      return "Pending";
    case DocumentState.uploading:
      return "Uploading";
    case DocumentState.converting:
      return "Converting";
    case DocumentState.conversionFailed:
      return "Error";
    case DocumentState.studentReview:
      return "Review";
    case DocumentState.evaluating:
    case DocumentState.submitted:
      if (props.isStudent == true) {
        return "Submitted";
      }

      return "Ready to Grade";
    case DocumentState.graded:
      return "Graded";
    case DocumentState.grading:
      return "Started Grading";
    case DocumentState.notImported:
      return "Not Submitted";
    case DocumentState.googlePermissionError:
      return "Permission Error";
    case DocumentState.editing:
      return "Draft";
    default:
      return "Unknown";
  }
});
</script>

<template>
  <div
    class="flex flex-row items-center"
    :aria-busy="isLoading"
    :class="{
      'h-[42px] text-center w-[180px] rounded': isConsolidatedView != true,
      'py-[2px] px-[4px] text-body-2 rounded-md': isConsolidatedView == true,
      'bg-danger-default border-danger-default text-danger-on border-2 justify-center ':
        filled &&
        (state == DocumentState.conversionFailed ||
          state == DocumentState.notImported ||
          state == DocumentState.googlePermissionError),
      'text-danger-default justify-end ':
        filled != true &&
        (state == DocumentState.conversionFailed ||
          state == DocumentState.notImported ||
          state == DocumentState.googlePermissionError),
      'bg-medium/60 border-medium/40 text-medium-on border-2 justify-center ':
        filled &&
        (state == DocumentState.submitted || state == DocumentState.evaluating),
      'text-medium-default border-medium-default  hover:bg-medium-default hover:text-medium-on border-2 justify-center ':
        filled != true &&
        (state == DocumentState.submitted || state == DocumentState.evaluating),
      ' bg-warning-default border-warning-default text-warning-on border-2 justify-center ':
        filled &&
        (state == DocumentState.pending ||
          state == DocumentState.uploading ||
          state == DocumentState.converting ||
          state == DocumentState.studentReview),
      ' text-warning-default border border-warning-default  hover:bg-warning-default hover:text-warning-on justify-center ':
        filled != true &&
        (state == DocumentState.pending ||
          state == DocumentState.uploading ||
          state == DocumentState.converting ||
          state == DocumentState.studentReview),
      ' bg-primary-default border-primary-default text-primary-on border-2 justify-center ':
        filled && state == DocumentState.grading,
      ' text-primary-default  border border-primary-default hover:bg-primary-default hover:text-primary-on justify-center ':
        filled != true && state == DocumentState.grading,
      ' bg-success-default border-success-default text-success-on border-2 justify-center ':
        filled && state == DocumentState.graded,
      ' text-success-default  border border-success-default hover:bg-success-default hover:text-success-on justify-center ':
        filled != true && state == DocumentState.graded,
      ' bg-purple-900 border-purple-900 text-success-on border-2 justify-center ':
        filled && state == DocumentState.editing,
      ' text-purple-900 border border-purple-900 hover:bg-purple-900 hover:text-primary-on justify-center ':
        filled != true && state == DocumentState.editing,
    }"
  >
    <icon
      v-if="isLoading"
      name="svg-spinners:ring-resize"
      size="14"
      class="mr-1 shrink-0"
      aria-hidden="true"
    />
    <span v-if="isLoading" class="sr-only" role="status">Opening document…</span>
    <span class="">
      {{ stateLabel }}
    </span>
    <span
      v-if="state == DocumentState.googlePermissionError"
      v-tooltip="
        'We do not have permission to import this file from Google. Please download the file from Google and upload manually.'
      "
      class="mt-[-3px]"
    >
      <icon name="material-symbols:help-outline" class="text-danger-on" />
    </span>
  </div>
</template>

<style scoped></style>
